<style scoped>
    .wage-record{
        border: 1px solid #dddee1;
        border-bottom: none;
        margin-bottom: 10px;
    }
    .wage-line{
        position: relative;
        padding: 5px 10px;
        border-bottom: 1px solid #dddee1;
    }
    .wage-item{
        display: inline-block;
        vertical-align: middle;
    }
    .wage-item-label{
        display: inline-block;
        vertical-align: middle;
        width: 200px;
        text-align: right;
    }
    .wage-item-value{
        display: inline-block;
        vertical-align: middle;
        width: 70px;
        text-align: right;
    }
    .line{
        margin: 1px 0;
    }
    .comment{
        display: inline-block;
        position: absolute;
        right: 2px;
        top: 2px;
        cursor: pointer;
    }
    .comment:hover{
        color: #000;
        text-decoration: underline;
    }
</style>
<template>
    <div class="wage-record">
        <div class="wage-line text-bold text-center">
            <span>{{record.account}} {{record.month}} 工资条</span>
            <div class="comment" v-if="showComment">
                <Button type="warning" size="small" @click="showComments">
                    <span>有疑问? 留言反馈</span>
                    <span v-if="record.comment_count">({{record.comment_count}}条留言)</span>
                </Button>
            </div>
        </div>
        <Row class="wage-line" v-if="false">
            <!--<i-col class="text-right" span="6">
                <span class="wage-item-label">月份:</span>
                <span class="wage-item-value">{{record.month}}</span>
            </i-col>-->
            <i-col class="text-left" span="8">
                <span class="wage-item-label">姓名:</span>
                <span class="wage-item-value">{{record.account}}</span>
            </i-col>
            <i-col class="text-left" span="8">
                <span class="wage-item-label">工号:</span>
                <span class="wage-item-value">{{record.uid}}</span>
            </i-col>
            <i-col class="text-right" span="8">
                <span class="wage-item-label">所属单位:</span>
                <span class="wage-item-value">{{record.content.company}}</span>
            </i-col>
        </Row>
        <div class="wage-line text-right">
            ( <div class="wage-item">
            <span class="wage-item-label1">税前基准工资:</span>
            <span class="wage-item-value1">{{formatPrice(record.content.wbtb)}}</span>
        </div>
            <div class="wage-item" v-if="record.content.wadj">
                <span class="wage-item-label1">当期调整合计:</span>
                <span class="wage-item-value1">{{formatPrice(record.content.wadj)}}</span>
            </div>
            <div class="wage-item" v-if="record.content.wdps">
                <span class="wage-item-label1">异地房补:</span>
                <span class="wage-item-value1">{{formatPrice(record.content.wdps)}}</span>
            </div>
            <div class="wage-item" v-if="record.content.wos">
                <span class="wage-item-label1">餐补:</span>
                <span class="wage-item-value1">{{formatPrice(record.content.wos)}}</span>
            </div>
            <div class="wage-item" v-if="record.content.rb">
                <span class="wage-item-label1">推荐奖:</span>
                <span class="wage-item-value1">{{formatPrice(record.content.rb)}}</span>
            </div> )
            <div class="wage-item">
                <span class="wage-item-label">调整后税前工资:</span>
                <span class="wage-item-value">{{formatPrice(record.content.wbt)}}</span>
            </div>
        </div>
        <Row class="wage-line">
            <i-col span="12">
                <div class="line text-right">
                    <span class="wage-item-label">社保基数-养老:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.ssb)}}</span>
                </div>
                <div class="line text-right" v-if="record.content.ssbo">
                    <span class="wage-item-label">社保基数-其他:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.ssbo)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">养老单位缴存额:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.eic)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">医疗单位缴存额:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.mic)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">失业单位缴存额:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.uic)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">生育单位缴存额:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.bic)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">工伤单位缴存额:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.iic)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">大病单位缴存额:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.ciic)}}</span>
                </div>
                <div class="line text-right" v-if="record.content.eic_repair">
                    <span class="wage-item-label">养老单位补缴:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.eic_repair)}}</span>
                </div>
            </i-col>
            <i-col span="12">
                <div class="line text-right">-</div>
                <div class="line text-right" v-if="record.content.ssbo">-</div>
                <div class="line text-right">
                    <span class="wage-item-label">养老个人缴存额:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.eip)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">医疗个人缴存额:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.mip)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">失业个人缴存额:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.uip)}}</span>
                </div>
                <div class="line text-right" v-if="record.content.eip_repair">
                    <span class="wage-item-label">养老个人补缴:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.eip_repair)}}</span>
                </div>
            </i-col>
        </Row>
        <Row class="wage-line">
            <i-col span="12">
                <div class="line text-right">
                    <span class="wage-item-label">公积金基数:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.hfb)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">公积金单位缴存额:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.hfc)}}</span>
                </div>
            </i-col>
            <i-col span="12">
                <div class="line text-right">-</div>
                <div class="line text-right">
                    <span class="wage-item-label">公积金个人缴存额:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.hfp)}}</span>
                </div>
            </i-col>
        </Row>
        <Row class="wage-line" v-if="record.content.deduct_total">
            <i-col span="12">
                <div class="line text-right">
                    <span class="wage-item-label">子女教育:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.deduct_children)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">赡养父母:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.deduct_parent)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">继续教育:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.deduct_edu)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">住房贷款利息:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.deduct_house)}}</span>
                </div>
                <div class="line text-right">
                    <span class="wage-item-label">住房租金:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.deduct_rent)}}</span>
                </div>
            </i-col>
            <i-col span="12">
                <div class="line text-right">
                    <span class="wage-item-label">专项附加扣除:</span>
                    <span class="wage-item-value">{{formatPrice(record.content.deduct_total)}}</span>
                </div>
            </i-col>
        </Row>
        <div class="wage-line">
            <div class="line text-right" v-if="record.content.ti">
                <span class="wage-item-label">扣除三险一金后月税前工资:</span>
                <span class="wage-item-value">{{formatPrice(record.content.ti)}}</span>
            </div>
            <div class="line text-right">
                <span class="wage-item-label">个税:</span>
                <span class="wage-item-value">{{formatPrice(record.content.wt)}}</span>
            </div>
            <div class="line text-right">
                <span class="wage-item-label">税后工资:</span>
                <span class="wage-item-value">{{formatPrice(record.content.wat)}}</span>
            </div>
        </div>
        <div class="wage-line" v-if="record.content.cfcb">
            <div class="line text-right">
                <span class="wage-item-label">CFC奖金:</span>
                <span class="wage-item-value">{{formatPrice(record.content.cfcb)}}</span>
            </div>
            <div class="line text-right">
                <span class="wage-item-label">CFC奖金个税:</span>
                <span class="wage-item-value">{{formatPrice(record.content.cfct)}}</span>
            </div>
            <div class="line text-right">
                <span class="wage-item-label">税后CFC奖金:</span>
                <span class="wage-item-value">{{formatPrice(record.content.cfcat)}}</span>
            </div>
        </div>
        <div class="wage-line" v-if="record.content.prob">
            <div class="line text-right">
                <span class="wage-item-label">项目奖金:</span>
                <span class="wage-item-value">{{formatPrice(record.content.prob)}}</span>
            </div>
            <div class="line text-right">
                <span class="wage-item-label">项目奖金个税:</span>
                <span class="wage-item-value">{{formatPrice(record.content.prot)}}</span>
            </div>
            <div class="line text-right">
                <span class="wage-item-label">税后项目奖金:</span>
                <span class="wage-item-value">{{formatPrice(record.content.proat)}}</span>
            </div>
        </div>
        <div class="wage-line" v-if="record.content.yb">
            <div class="line text-right">
                <span class="wage-item-label">年底奖金:</span>
                <span class="wage-item-value">{{formatPrice(record.content.yb)}}</span>
            </div>
            <div class="line text-right">
                <span class="wage-item-label">年底奖金个税:</span>
                <span class="wage-item-value">{{formatPrice(record.content.yt)}}</span>
            </div>
            <div class="line text-right">
                <span class="wage-item-label">税后年底奖金:</span>
                <span class="wage-item-value">{{formatPrice(record.content.yat)}}</span>
            </div>
        </div>

        <RecordComment ref="comment" :record="record"></RecordComment>
    </div>
</template>
<script>
    import RecordComment from './record_comment';
    export default {
        components: { RecordComment },
        props: {
            record: {
                type: Object
            },
            type: {
                type: String,
                default: ''
            },
            showComment: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            showComments(){
                this.$refs.comment.show();
            },
            formatPrice(price){
                return Util.formatPrice(price);
            }
        }
    }
</script>
